
const searchModal = document.getElementById('search-modal');
const searchButtons = document.querySelectorAll('.search-toggle');

export let isSearchExpanded = false;

export function closeSearchModal() {
    isSearchExpanded = false;
    searchModal.setAttribute('tabindex', '-1');
    searchModal.setAttribute('inert', '');
    searchModal.setAttribute('aria-expanded', 'false');
    searchButtons.forEach((element) => {
        element.setAttribute('aria-expanded', 'false');
        element.setAttribute('aria-label', 'Åben søgning');
    })

    searchModal.classList.remove('active');
    document.body.classList.remove('no-scroll');
    const searchButton = searchButtons[0];
    setTimeout(() => {
        searchButton.focus();
    }, 200);
}

searchButtons.forEach((element) =>
    element.addEventListener('click', function () {
        if (isSearchExpanded == true && !element.closest('#mobile-navigation')) {
            closeSearchModal()
        }
        else {
            isSearchExpanded = true;
            searchModal.setAttribute('tabindex', '1');
            searchModal.removeAttribute('inert');
            searchModal.setAttribute('aria-expanded', 'true');
            element.setAttribute('aria-expanded', 'true');
            element.setAttribute('aria-label', 'Luk søgning');
            searchModal.classList.add('active');
            document.body.classList.add('no-scroll');

            setTimeout(() => {
                const searchInput = document.getElementById('search-input');
                if (searchInput) {
                    // Try to focus
                    searchInput.focus();

                    // Debug: Check if focus actually applied
                    if (document.activeElement !== searchInput) {
                        console.warn('Focus failed. Element exists but browser rejected focus.');
                    }
                } else {
                    console.error('Element not found in DOM yet.');
                }
            }, 500);
        }
    })
)

document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && searchModal.classList.contains('active')) {
        closeSearchModal();
    }
});
